import { NgModule } from '@angular/core';
import { CalendarioPagoPensionRoutingModule } from './calendario-pago-pension-routing.module';
import { CalendarioPagoPensionHomeComponent } from './pages/calendario-pago-pension-home/calendario-pago-pension-home.component';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

@NgModule({
  declarations: [
    CalendarioPagoPensionHomeComponent,
  ],
  imports: [
    CalendarioPagoPensionRoutingModule,
    CommonModule,
    IonicModule,
  ]
})
export class CalendarioPagoPensionModule {}